import WithHOC from './WithHOC';

export default WithHOC;
